import { Tab } from "@material-ui/core"
import { Link } from "react-router-dom"

const LinkTab = (props) => {
  return <Tab disableRipple component={Link} {...props} />
}

export default LinkTab
